import { ArrowLink } from '#/components/ui/ArrowLink';
import type { AboutFinraView } from '#/content/homepage';

import { BrandAccent } from '../ui/BrandAccent';

interface MoreAboutFinraSectionProps {
  content: AboutFinraView;
}

export function MoreAboutFinraSection({ content }: MoreAboutFinraSectionProps) {
  return (
    <div className="bg-steel-10 grid gap-24 rounded p-32 lg:grid-cols-3 lg:items-end lg:gap-32 lg:p-60">
      <header className="flow flow-12">
        <BrandAccent variant="long" />
        <h2 className="text-fluid-subheader leading-none font-semibold">
          More About{' '}
          <span className="text-fluid-accent-xl ml-[-0.05em] block">FINRA</span>
        </h2>
      </header>

      <div className="space-y-16 lg:col-span-2">
        <h3 className="text-fg-header text-fluid-subheader leading-tight font-semibold">
          {content.subtitle}
        </h3>

        <p className="text-fluid-base text-fg-muted leading-relaxed">
          {content.description}
        </p>

        {content.link ? (
          <ArrowLink
            href={content.link.href}
            className="text-link-fg text-fluid-base-sm"
            dataTrack="home_more_about_finra"
            dataTrackLabel={content.link.label}
            dataTrackContext="about_finra"
          >
            {content.link.label}
          </ArrowLink>
        ) : null}
      </div>
    </div>
  );
}
